import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { capitalizeFirstLetter } from "../../../../utils/common";
import { history } from "../../../../store/configure/configureStore";

import connect from "react-redux/es/connect/connect";
import {
  getDeviceList,
  getStatusList,
  getBannerScreenList,
  getSubscriptionList,
} from "../../../../store/master/masterActions";
import {
  updateBanner,
  getBannerById,
} from "../../../../store/BannerManagement/BannerManagementActions";

import ViewBannerView from "./ViewBannerView";

class ViewBannerContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newFields: {
        title: {
          title: "",
          color: "",
          visibility: { label: "show", value: "show" },
          fontSize: "14",
          modalTitle: "",
          active: false,
        },
        subTitle: {
          subTitle: "",
          color: "",
          visibility: { label: "show", value: "show" },
          fontSize: "12",
          modalTitle: "",
          active: false,
        },
        primaryBtnTitle: {
          primaryBtnTitle: "",
          color: "",
          visibility: "",
          fontSize: "12",
          modalTitle: "",
          active: false,
          BtnActionURL: "",
          type: "button",
        },
        secondaryBtnTitle: {
          secondaryBtnTitle: "",
          color: "",
          visibility: "",
          fontSize: "12",
          modalTitle: "",
          active: false,
          BtnActionURL: "",
          type: "button",
        },
      },
      imageBackgroundColor: "",
      device: null,
      status: null,
      bannerScreen: null,
      checkedItems: [],
      file: null,
      fileInput: null,
    };

    this.handleDeviceChange = this.handleDeviceChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.bannerById !== this.props.bannerById) {
      this.handlePreFillValuesInState();
      this.handlePrefillForCheckedItems();
    }

    // Check if deviceList has changed and device is null
    if (this.state.device === null) {
      this.props.deviceList.forEach((item) => {
        if (item.name === "Iphone 11") {
          this.setState({
            device: item,
          });
        }
      });
    }
  }

  componentDidMount() {
    const { id } = this.props.match?.params; //get id of banner from url

    this.props.getBannerById(id);
    this.props.getSubscriptionList();
    this.props.getDeviceList();
    this.props.getStatusList();
  }

  componentWillUnmount() {}

  handlePreFillValuesInState = () => {
    console.log("bannerById", this.props.bannerById);
    const checkedItems = this.handlePrefillForCheckedItems();

    const {
      button = [],
      subTitle = {},
      title = {},
      status = {},
      bannerTitle = "",
      presignedUrl = "",
      bannerScreenId = {},
      imageBackgroundColor = "",
    } = this.props?.bannerById || {};

    const primaryButton = button[0];
    const secondaryButton = button[1];

    this.setState((prev) => ({
      ...prev,
      newFields: {
        title: {
          ...prev.newFields.title,
          title: title?.text,
          color: title?.color,
          visibility: {
            label: `${title?.visible}`,
            value: `${title?.visible}`,
          },
          fontSize: title?.fontSize || 14,
        },
        subTitle: {
          ...prev.newFields.subTitle,
          subTitle: subTitle?.text,
          color: subTitle?.color,
          visibility: {
            label: `${subTitle?.visible}`,
            value: `${subTitle?.visible}`,
          },
          fontSize: subTitle?.fontSize || 12,
        },
        primaryBtnTitle: {
          ...prev.newFields.primaryBtnTitle,
          primaryBtnTitle: primaryButton?.title,
          color: primaryButton?.color,
          visibility: {
            label: `${primaryButton?.visible}`,
            value: `${primaryButton?.visible}`,
          },
          fontSize: primaryButton?.fontSize || 12,
          BtnActionURL: primaryButton?.buttonUrl,
        },
        secondaryBtnTitle: {
          ...prev.newFields.secondaryBtnTitle,
          secondaryBtnTitle: secondaryButton?.title,
          color: secondaryButton?.color,
          visibility: {
            label: `${secondaryButton?.visible}`,
            value: `${secondaryButton?.visible}`,
          },
          fontSize: secondaryButton?.fontSize || 12,
          BtnActionURL: secondaryButton?.buttonUrl,
        },
      },
      status: { label: `${status?.status}`, value: `${status?._id}` },
      fileInput: presignedUrl,
      imageBackgroundColor: imageBackgroundColor,
      checkedItems: checkedItems,
      bannerScreen: bannerScreenId
        ? {
            label: `${bannerScreenId?.label}`,
            value: `${bannerScreenId?._id}`,
          }
        : null,
    }));
  };

  //this is used for marking checked in check list if data is available
  handlePrefillForCheckedItems = () => {
    const {
      subscriptionId = [],
      sahaj = false,
      sky = false,
    } = this.props?.bannerById || {};

    // Transform subscriptionId into the desired format
    const subscriptionItems = subscriptionId.map((item) => ({
      id: item._id,
      name: item.name,
      isFlagItem: false,
    }));

    // Create flag items
    const flagItems = [
      {
        id: "sahaj-id",
        name: "Sahaj",
        isFlagItem: true,
      },
      {
        id: "sky-id",
        name: "Sky",
        isFlagItem: true,
      },
    ];

    // Filter flag items based on their respective flags
    const checkedFlagItems = flagItems.filter((flagItem) => {
      const flagValue = this?.props?.bannerById?.[flagItem?.name.toLowerCase()];
      return flagValue; // Include item if flag value is true
    });

    // Combine subscription items and checked flag items
    const checkedItems = [...subscriptionItems, ...checkedFlagItems];

    // console.log("checkedItems", checkedItems);
    return checkedItems;
  };

  //-------------------handle Device Change
  handleDeviceChange = (val) => {
    const selectedDevice = this.props.deviceList?.find(
      (item) => item?.name === val?.label
    );
    this.setState((prev) => ({
      ...prev,
      device: selectedDevice,
    }));
  };

  render() {
    const { deviceList, status } = this.props;

    const deviceDropDownOptions =
      deviceList?.map((item) => ({
        label: item?.name,
        value: item?.id,
      })) || [];

    return (
      <ViewBannerView
        newFields={this.state.newFields}
        status={this.state.status}
        bannerScreen={this.state.bannerScreen}
        fileInput={this.state.fileInput}
        device={this.state.device}
        checkedItems={this.state.checkedItems}
        imageBackgroundColor={this.state.imageBackgroundColor}
        //
        subscriptionList={this.props.subscriptionList}
        //
        deviceDropDownOptions={deviceDropDownOptions}
        //
        handleDeviceChange={this.handleDeviceChange}
      />
    );
  }
}

ViewBannerContainer.propTypes = {};

const mapStateToProps = (state) => ({
  bannerById: state.bannerManagement.bannerById,
  deviceList: state.master.deviceList,
  status: state.master.status,
  bannerScreenList: state.master.bannerScreenList,
  subscriptionList: state.master.subscriptionList,
});

export default connect(mapStateToProps, {
  getBannerById,
  getDeviceList,
  getStatusList,
  updateBanner,
  getBannerScreenList,
  getSubscriptionList,
})(ViewBannerContainer);
